import React from "react";
import target from "../assets/imgTwo/target.svg";
// import light from "../assets/imgTwo/bulb.svg";
import celebrate from "../assets/imgTwo/celebrate.svg";
import guy from "../assets/imgTwo/guyGallery.svg";
import girl from "../assets/imgTwo/girlCoffee.svg";
import laptop from "../assets/imgTwo/girlLaptop.svg";
import team from "../assets/imgTwo/team.svg";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const GallerySection = () => {
  return (
    <section
      id="about"
      className=" py-16 animate-slidein"
    >
      <h2 className="text-2xl md:text-[3.5rem] font-bold mb-4 leading-normal text-white text-center my-12">
        Redefining The Future of Payments<br></br> Secure, Seamless, and<br></br>
        Scalable.
      </h2>



      <div className="w-full max-w-screen-xl mx-auto pt-12 px-4 overflow-scroll">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 h-screen">
          <div className="md:col-span-2 flex flex-col gap-4">
            <img
              src={team}
              alt="Big 1"
              className="w-full h-[70%] object-cover rounded-lg"
            />
            <img
              src={celebrate}
              alt="Big 2"
              className="w-full h-[30%] object-cover rounded-lg"
            />
          </div>

          {/* Column 2 (Spans 1 column) */}
          <div className="flex flex-col gap-4">
            <img
              src={laptop}
              alt="Small 1"
              className="w-full h-[30%] object-cover rounded-lg"
            />
            <img
              src={girl}
              alt="Small 2"
              className="w-full h-[70%] object-cover rounded-lg"
            />
          </div>

          <div className="md:col-span-1">
            <img
              src={guy}
              alt="Small 3"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>
      </div>

    </section>
  );
};
export const HeroSection = () => {
  return (
    <section
      id="about"
      className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
    >
      <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
            Mission
          </h2>
          <p className="text-gray-800 text-lg">
            Simplifying payments for financial convenience and growth
          </p>


        </div>
        <div className="w-full md:w-[35em] p-2 flex md:justify-end">
          <img src={target} alt="sarepay" className="rounded-lg" />

        </div>
      </div>
    </section>
  );
};

const AboutSection = () => (
  <section
    id="home"
    className=" bg-[#F7F7F7] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col justify-between md:flex-row items-center">
      <div className="w-full md:w-1/2 p-4">
        <img src={target} alt="mozfin" className="rounded-lg" />
      </div>
      <div className="w-full md:w-1/2 p-4">
        <div className="mb-8">
          <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
            Vision
          </h2>
          <p className="text-gray-800 text-lg">
            Transforming the future of payments to make every transaction effortless, secure and profitable
          </p>
        </div>
        <div>
          <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
            Mission
          </h2>
          <p className="text-gray-800 text-lg">
            Simplifying payments for financial convenience and growth
          </p>
        </div>

      </div>


    </div>

  </section>
);


export const About = () => (
  <div className="font-san mx-auto bg-[#000000] pt-6">
    <Navbar />
    <GallerySection />
    {/* <HeroSection /> */}
    <AboutSection />
    <Footer />
  </div>
);

export default About;
